import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { UserService } from '../services/user.service';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { error } from 'util';
import { AbstractControl } from '@angular/forms/src/model';
import { User } from '../feature-modules/admin/user/modals/user.modal';

@Component({
  selector: 'app-user-set-password',
  templateUrl: './user-set-password.component.html',
  styleUrls: ['./user-set-password.component.scss']
})
export class UserSetPasswordComponent implements OnInit {
  invalid: Boolean = true;
  passwordHash1: any;
  passwordHash2: any;
  passwordError: boolean = false;
  newpasswordType: boolean = false;
  confirmpasswordType: boolean = false;
  user: User=new User();
  flag: boolean = false;
  tokens: any;
  successflog: boolean=false;
  orgCode:any;
  public setpasswordFormGroup:FormGroup;
  public passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[#_+-=$@$!%*?&])[A-Za-z\d$@$!%*?&].{7,}$/;
  doesMatchPassword: boolean=false;

  constructor(private formBuilder: FormBuilder, private router: Router,
    private userService: UserService, private activatedRoute: ActivatedRoute) {
//  password Match code
this.setpasswordFormGroup = this.formBuilder.group({
  newPassword: ['', [Validators.required,Validators.pattern(this.passwordRegex)]],
  confirmPassword: ['',[Validators.required]]
}, {
  validator: this.validate.bind(this)
});
  }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      this.tokens = params['token']
    })
    this.checkValidityOfToken();
    this.subscribechangepasswordForm()
  }


  validate(setpasswordFormGroup: FormGroup) {
    const repeatPassword = setpasswordFormGroup.controls.confirmPassword.value;
    const password = setpasswordFormGroup.controls.newPassword.value;

      if (repeatPassword.length <= 0) {
       return this.doesMatchPassword=false;
    }
    if (repeatPassword !== password) {
            this.doesMatchPassword=true;
    }
    else{
      this.doesMatchPassword=false;
    }
}

public subscribechangepasswordForm() {

  this.setpasswordFormGroup.valueChanges.subscribe(value=>{
    value ? this.setpasswordFormGroup.controls.newPassword.valid : null;

  })
}

  checkValidityOfToken() {
    this.userService.checkValidityOfToken(this.tokens).subscribe(data => {
      this.user = data;
      if (this.user.userId == null) {
        this.flag = true;
        this.successflog=false;
      }
    });
  }

  setPassword() {

    // if (this.passwordHash2 !== this.passwordHash1) {
    //   this.passwordError = true;
    // }
    if(this.setpasswordFormGroup.valid&&this.doesMatchPassword==false) {
      

      this.user.passwordHash = this.confirmPassword.value;
      this.userService.UpdatePassword(this.user, this.tokens).subscribe(Response => {
        
        this.successflog=true;
        this.flag = false;
        this.orgCode = Response['organisation']['code'];
        localStorage.setItem('logo',this.orgCode);
      }, error => {
        
        this.flag = false;
      })
    }

  }

public goToLoginPage(){
  this.router.navigate(['/login/',this.orgCode]);
}

  protected get passwordHash(): AbstractControl {
    return this.setpasswordFormGroup.get('passwordHash');
  }
  protected get newPassword(): AbstractControl {
    return this.setpasswordFormGroup.get('newPassword');
  }

  protected get confirmPassword(): AbstractControl {
    return this.setpasswordFormGroup.get('confirmPassword');
  }
}



// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/app/user-set-password/user-set-password.component.ts